export default __webpack_public_path__ + "static/media/photo--lg--99.26faa800.jpg";